import React, { FC } from "react";

import AddToFavorite from "AddToFavorite";
import LabelGalaxy from "composants/LabelGalaxy";
import SatellitesIndicateurBar from "containers/satellites/SatellitesIndicateurBar";

import ActiveTabGalaxy from "composants/menu/ActiveTabGalaxy";
import { ModeDebugIcon } from "composants/userSettings/ModeDebug";
import { SuperUserIcon } from "composants/userSettings/SuperUser";

import { LeGrosMenu } from "layout/top/LeGrosMenu";
import { AppGalaxyInfo } from "types/Galaxy";
import { Settings } from "./Settings";
import { SearchGalaxies } from "./SearchGalaxies";
import { NotificationMenu } from "./NotificationMenu";
import { EnvironmentBadge } from "./Ribbon";
import ProcessDelayedMenu from "./ProcessDelayedMenu";
import EntityLogoTopBar from "composants/userSettings/EntityLogoTopBar";
import { useLocation } from "react-router-dom";
import { tw } from "twind";

interface TopbarProps {
  favoris: AppGalaxyInfo[];
  galaxies: Record<string, AppGalaxyInfo>;
  changeMenuFavoris(newFavoris: AppGalaxyInfo[]): void;
}

const Topbar: FC<TopbarProps> = ({ favoris, galaxies, changeMenuFavoris }) => {
  const location = useLocation();
  return (
    <div className={tw("sticky top-0 z-30")}>
      <header
        style={{
          backgroundColor: "var(--system-surface, #ffffff)",
          borderBottom: "1px solid var(--system-border, #e3e7ee)",
          paddingTop: 8,
          paddingBottom: 8,
          zIndex: 30,
        }}
      >
        <nav className="level" style={{ margin: "0 10px" }}>
          {/*west header*/}
          <div className="level-left">
            <div className="level-item">
              <LeGrosMenu />
            </div>
            <div className="level-item">
              <SearchGalaxies galaxies={galaxies} />
            </div>
            <div className="level-item">
              <EntityLogoTopBar />
            </div>
            <div className="level-item">
              <ModeDebugIcon />
            </div>
            <div className="level-item">
              <SuperUserIcon />
            </div>
          </div>

          <div
            className="level-item has-text-centered"
            style={{ position: "absolute", left: "calc(50% - 10rem)", width: "20rem" }}
          >
            <AddToFavorite favoris={favoris} afterToggle={changeMenuFavoris} />
            <LabelGalaxy galaxies={galaxies} location={location} />
          </div>

          <div className="level-right">
            <div className="level-item">
              <SatellitesIndicateurBar />
            </div>
            <div className="level-item">
              <ProcessDelayedMenu />
            </div>
            <div className="level-item">
              <NotificationMenu />
            </div>
            <div className="level-item">
              <Settings />
            </div>
          </div>
        </nav>
      </header>
      <div
        style={{
          backgroundColor: "var(--system-surface, #ffffff)",
          borderBottom: "1px solid var(--system-border, #e3e7ee)",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div style={{ flex: 1, minWidth: 0 }}>
          <ActiveTabGalaxy />
        </div>
        <EnvironmentBadge style={{ margin: "0 10px" }} />
      </div>
    </div>
  );
};

export default Topbar;
